<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card id="newChecklistDialog">
      <v-card-title><h2>{{ title }}</h2></v-card-title>
      <v-card-text class="mb-6">
          <v-text-field label="Titel der Checkliste" v-model="inputText"></v-text-field>
          <v-textarea label="Zusätzliche Beschreibung" v-model="description"></v-textarea>
          <div class="d-inline-flex align-baseline">
            <h4>Wählen Sie die zu verknüpfende Umfrage aus</h4>
            <div class="infobox-container" >
              <div class="infobox-container__icon"
                   @mouseover="showInfobox('infoBox', infoText)"
                   @mouseleave="hideInfobox('infoBox_')">
                <v-icon color="primary">mdi-information-outline</v-icon>
              </div>
              <InfoboxChecklist ref="infoBox"/>
            </div>
          </div>
          <v-select
          :disabled="surveys.length < 1"
          v-model="connectedSurveyId"
          :items="surveys"
          item-text="title"
          item-value="id"
          label="Verknüpfte Umfrage"
        ></v-select>
      </v-card-text>
      <v-card-actions class="pr-6 pb-6">
        <v-btn id="leftButton" text @click.stop="cancel">Abbrechen</v-btn>
        <v-btn id="rightButton" elevation="0" @click.stop="agree" color="primary">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import surveyService from "@/pages/PxQuestionSurvey/PXSurveyPage/px-survey-service"
import InfoboxTooltip from "../../components/common/InfoboxTooltip.vue";
import InfoboxChecklist from "./InfoboxChecklist.vue";
export default {
    name: "NewChecklistDialog",
    data() {
        return {
            dialog: false,
            resolve: null,
            reject: null,
            inputText: "",
            title: null,
            options: {
                width: 600,
                zIndex: 200,
            },
            connectedSurveyId: -1,
            surveys: [],
            description: "",
            infoText: "Für die Checklistenfunktion muss eine Umfrage aus dem Bindungsmodul verknüpft sein. Sie können diese jetzt verknüpfen, oder im laufe des ersten Schritts der Checkliste nachträglich verknüpfen."
        };
    },
    methods: {
        open(title, options) {
            surveyService.retrievePXSurveysByModule(1).then(res => {
                this.surveys = res.data;
                this.surveys.unshift({
                    id: -1,
                    title: "Umfrage später verknüpfen"
                });
                this.dialog = true;
                this.title = title;
                this.options = Object.assign(this.options, options);
            });
            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        agree() {
            this.resolve({
                title: this.inputText,
                connectedSurvey: this.connectedSurveyId,
                description: this.description
            });
            this.dialog = false;
        },
        cancel() {
            this.reject(false);
            this.dialog = false;
        },
        showInfobox(ref, infoText) {
          let selectedComponent = this.$refs[ref];

          if (Array.isArray(selectedComponent)) {
            return selectedComponent[0].open(infoText);
          } else {
            return selectedComponent.open(infoText);
          }
        },
        hideInfobox(idx) {
          this.$refs['infoBox'].close();
        }
    },
    components: { InfoboxTooltip, InfoboxChecklist }
};
</script>